import React from "react";

function Demo(props) {
  return (
    <div className="w-full flex flex-wrap lg:justify-around justify-center gap-y-10">
      {props.demos.map((demo, idx) => (
        <div key={idx} className="lg:w-[48%] w-[90%] drop-shadow-md">
          <video autoPlay loop muted src={demo} className="rounded-md " />
        </div>
      ))}
    </div>
  );
}

export default Demo;
